export const getBorrowerFullNames = (
  borrowerFirstName: string,
  borrowerLastName: string,
  coBorrowerFirstName?: string | null,
  coBorrowerLastName?: string | null,
) => {
  return (
    `${borrowerFirstName} ${borrowerLastName}` +
    (!!coBorrowerFirstName ? ` and ${coBorrowerFirstName} ${coBorrowerLastName}` : '')
  );
};

export const getBorrowerNames = (borrowerFirstName: string, coBorrowerFirstName?: string | null) => {
  return borrowerFirstName + (!!coBorrowerFirstName ? ` and ${coBorrowerFirstName}` : '');
};
